export default __webpack_public_path__ + "static/media/SignupCarouselSS4.94b41a68.svg";